import { FaInstagram, FaTwitter } from "react-icons/fa";
import { Divider, Flex, Heading, Stack, Text } from "@chakra-ui/react";

import { ContactInfo } from "../components/contactInfo";
import { FooterButton } from "../components/FooterButton";
import { SocialButton } from "../components/SocialButton";

import { emailLink, smsLink } from "../helpers";

export const Footer = () => {
	return (
		<Stack w="100%" bg="brand.mid">
			<Flex p="8" align="flex-start" justify="space-between">
				<Stack w="33%" gap="3.5">
					<Stack gap="1">
						<Heading>LULU</Heading>
						{/* <Text>Melbourne, Australia</Text> */}
					</Stack>

					<Divider
						borderRadius="3"
						borderWidth="1px"
						borderColor="brand.contrast"
					/>

					<Stack gap="1">
						<ContactInfo
							label="text me at"
							value="0493 439 302"
							link={smsLink}
						/>

						<ContactInfo
							label="email me at"
							value="hello@lulureynolds.com.au"
							link={emailLink}
						/>
					</Stack>
				</Stack>

				<Stack w="33%" align="center">
					<FooterButton label="HOME" path="/#" />
					<FooterButton label="EXPERIENCE" path="/#experience" />
					<FooterButton label="COMPENSATION" path="/#compensation" />
					<FooterButton label="FAQS" path="/#faqs" />
					{/* <FooterButton label="TESTIMONIALS" path="/#testimonials" /> */}
					<FooterButton label="CONTACT" path="/#contact" />
					<FooterButton label="GALLERY" path="/#gallery" />
					{/* <FooterButton label="ANNOUNCEMENTS" path="/#announcements" /> */}
				</Stack>

				<Stack w="33%" gap="3.5">
					<Stack gap="1" align="flex-end">
						<FooterButton
							label="MEET ME"
							path="https://www.lulureynolds.com.au/#"
							isExternal
						/>
						{/* <FooterButton
              label="SHOP ME"
              path="https://www.shop.lulureynolds.com"
              isExternal
            /> */}
						<FooterButton
							label="WATCH ME"
							path="https://www.onlyfans.com/lulureynoldsx"
							isExternal
						/>
					</Stack>

					<Divider
						borderRadius="3"
						borderWidth="1px"
						borderColor="brand.contrast"
					/>

					<Stack gap="1" align="flex-end">
						<FooterButton
							label="ONLYFANS"
							path="https://www.onlyfans.com/lulureynoldsx"
							isExternal
						/>
						<FooterButton
							label="MANYVIDS"
							path="https://www.manyvids.com/Profile/537557/LuluReynolds/Store/Videos/"
							isExternal
						/>
					</Stack>
					<Flex gap="1" justify="flex-end">
						<SocialButton
							link="https://www.instagram.com/thetitfairy"
							label="instagram"
							icon={FaInstagram}
						/>
						<SocialButton
							link="https://www.twitter.com/lulureynoldsx"
							label="twitter"
							icon={FaTwitter}
						/>
					</Flex>
				</Stack>
			</Flex>

			<Flex
				py="2"
				px="8"
				fontSize="sm"
				bg="brand.dark"
				color="brand.light"
				justify="space-between"
			>
				<FooterButton label="Back to top" path="/#" />

				<Text>
					© 2025{" "}
					<FooterButton
						label="Mes Cheries"
						path="https://www.mescheries.com.au"
					/>
				</Text>
			</Flex>
		</Stack>
	);
};
